import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'Houseful (THEO) designs for Sri Sakthi Cinemas';
render(<App data-id="element-270" />, document.getElementById('root'));